import { OrderFeature } from '@aloft/toolkit-shared';

import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import {
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';
import { handleUpdatePropertyData } from '../../../components/PropertyGrid/utils.ts';
import { setOrderFeatures } from '../../../redux/features/orderSlice.ts';
import { selectOrderFeatures } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';
import { FEATURE_GRID_ORDER_FEATURES } from '../consts.ts';

type FeatureGridFeatureSectionProps = PropertyGridSectionProps & {
  feature: OrderFeature;
};

const FeatureGridFeatureSection = (props: FeatureGridFeatureSectionProps) => {
  const { feature, hasUnitRate } = props;
  const { label, propertyGridFields } = FEATURE_GRID_ORDER_FEATURES[feature];

  if (hasUnitRate) {
    propertyGridFields.forEach((field) => {
      if (
        ['editableData.improvements.garage.spaces', 'editableData.improvements.detachedGarage.spaces', 'editableData.improvements.carport.spaces'].includes(field.fieldName)
      ) {
        // eslint-disable-next-line no-param-reassign
        field.required = true;
      }
    });
  }

  return (
    <PropertyGridSection {...props} title={label} hasSeparateArvValue fields={propertyGridFields} />
  );
};

export const FeatureGridFeatureSections = (props: PropertyGridSectionProps) => {
  const dispatch = useAppDispatch();
  const { setValue, getValues } = props;
  const orderFeatures = useAppSelector(selectOrderFeatures);
  const sortedOrderFeatures: OrderFeature[] = orderFeatures
    .filter((feature) => feature !== 'manualCost')
    .sort((a, b) => a.localeCompare(b));
  if (orderFeatures.includes('manualCost')) sortedOrderFeatures.push('manualCost');

  return sortedOrderFeatures.map((feature) => (
    <FeatureGridFeatureSection
      key={feature}
      feature={feature}
      isRemovable
      onRemove={() => {
        // Remove from Redux state
        dispatch(setOrderFeatures(orderFeatures.filter((f) => f !== feature)));

        // Clear form state for this feature across all columns
        const columns = getValues('columns');
        columns.forEach((column, columnIndex) => {
          if (column.type !== 'property') return;
          let { propertyData } = column;
          const { propertyId } = column;

          if (propertyData?.editableData?.improvements) {
            // Clear the specific feature field
            const featureFieldName = `columns.${columnIndex}.propertyData.editableData.improvements.${feature}`;
            setValue(featureFieldName as any, undefined);

            propertyData = getValues(`columns.${columnIndex}.propertyData`);
            handleUpdatePropertyData(propertyId, getValues(), dispatch, propertyData);
          }
        });
      }}
      {...props}
    />
  ));
};
